import { Fragment } from 'react';

import {
  Combobox,
  ComboboxChip,
  ComboboxChips,
  ComboboxChipsInput,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxItem,
  ComboboxList,
  ComboboxValue,
  useComboboxAnchor
} from '@/components/ui/combobox';
import { useMultiSelect } from './model';
import type { SelectOption } from './simple-select';

interface SimpleMultiSelectProps {
  options: SelectOption[];
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
  emptyMessage?: string;
  className?: string;
}

export function SimpleMultiSelect({
  options,
  value,
  onChange,
  placeholder = 'Select options',
  emptyMessage = 'No items found.',
  className = 'w-full max-w-xs'
}: SimpleMultiSelectProps) {
  const anchor = useComboboxAnchor();

  const { items, selectedLabels, handleValueChange, getLabelKey } = useMultiSelect({
    options,
    value,
    onChange
  });

  return (
    <Combobox items={items} multiple autoHighlight value={selectedLabels} onValueChange={handleValueChange}>
      <ComboboxChips ref={anchor} className={className}>
        <ComboboxValue>
          {(labels) => (
            <Fragment>
              {(labels as string[]).map((label) => (
                <ComboboxChip key={getLabelKey(label)}>{label}</ComboboxChip>
              ))}
              <ComboboxChipsInput placeholder={value.length === 0 ? placeholder : undefined} />
            </Fragment>
          )}
        </ComboboxValue>
      </ComboboxChips>
      <ComboboxContent anchor={anchor}>
        <ComboboxEmpty>{emptyMessage}</ComboboxEmpty>
        <ComboboxList>
          {(label) => (
            <ComboboxItem key={getLabelKey(label)} value={label}>
              {label}
            </ComboboxItem>
          )}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
